import {Component, OnInit} from '@angular/core';
import {AppRoutes} from "../../enums/routes";
import {AlertLevel} from "../../enums/alert-level";
import {PermissionService} from "../../_auth/permission.service";
import {CompositionTypeService} from "../../_services/composition-type.service";
import {CompositionTypeHttpService} from "../../http-requests/composition-type-http.service";
import {GlobalAlertService} from "../../_services/global-alert.service";
import {InventoryRoutes} from "../../_modules/inventory/inventory.routes";
import {NavbarItemLargeComponent} from "../navbar-base/navbar-item-large/navbar-item-large.component";
import {NavbarContainerComponent} from "../navbar-base/navbar-container/navbar-container.component";
import {NavbarItemSmallComponent} from "../navbar-base/navbar-item-small/navbar-item-small.component";
import {
  NavbarItemSmallContainerComponent
} from "../navbar-base/navbar-item-small-container/navbar-item-small-container.component";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-navbar-inventory',
  templateUrl: './navbar-inventory.component.html',
  imports: [
    CommonModule,
    NavbarItemLargeComponent,
    NavbarContainerComponent,
    NavbarItemSmallComponent,
    NavbarItemSmallContainerComponent
  ],
  styleUrls: ['./navbar-inventory.component.scss']
})
export class NavbarInventoryComponent implements OnInit {
  protected readonly Routes = AppRoutes;
  protected readonly InventoryRoutes = InventoryRoutes;

  constructor(public PermissionService: PermissionService, public CompositionTypeService: CompositionTypeService,
              protected compositionTypeHttpService: CompositionTypeHttpService, private globalAlertService: GlobalAlertService) {
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    if (!this.PermissionService.CheckPermission(this.PermissionService.Inventory_CompositionType_ListNl())) {
      this.CompositionTypeService.CompositionTypes = [];
      return;
    }
    this.compositionTypeHttpService.ListNl().subscribe(x => {
      this.CompositionTypeService.CompositionTypes = x;
    }, error => {
      console.error(error);
      this.globalAlertService.createAlertBannerModel("Fehler", "Artikel-Kategorien konnten nicht geladen werden.", AlertLevel.error, 2000);
      this.globalAlertService.show();
    })
  }

  protected readonly AppRoutes = AppRoutes;
}
